import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Loader2, AlertCircle, CheckCircle2 } from "lucide-react";
import { Header } from "@/components/landing/Header";
import { Footer } from "@/components/landing/Footer";
import { API, apiError } from "@/lib/api";

export const SimpleCard = ({ testid, children }) => (
  <div data-testid={testid}>
    <Header />
    <main className="bg-ice-soft min-h-[70vh] flex items-center">
      <div className="container-x max-w-2xl py-16">
        <div className="order-card p-8 sm:p-12 flex flex-col items-center text-center gap-5">{children}</div>
      </div>
    </main>
    <Footer />
  </div>
);

export default function ResumeOrder() {
  const { token } = useParams();
  const [params] = useSearchParams();
  const [state, setState] = useState({ kind: "loading" });

  useEffect(() => {
    document.title = "Reprendre ma commande | ClimNova";
    axios.post(`${API}/orders/resume/${token}`, { code: params.get("code") })
      .then(({ data }) => (data.already_paid ? setState({ kind: "paid", order: data.order_id }) : (window.location.href = data.checkout_url)))
      .catch((e) => setState({ kind: "error", msg: apiError(e) }));
  }, [token, params]);

  return (
    <SimpleCard testid="resume-page">
      {state.kind === "loading" && (
        <>
          <Loader2 className="w-12 h-12 text-sky-600 animate-spin" />
          <h1 className="font-display text-3xl font-extrabold text-slate-900">Préparation de votre paiement…</h1>
          <p className="text-slate-600">Nous recalculons le prix en vigueur et vous redirigeons vers la page de paiement sécurisée.</p>
        </>
      )}
      {state.kind === "paid" && (
        <>
          <CheckCircle2 className="w-14 h-14 text-emerald-600" />
          <h1 data-testid="resume-already-paid" className="font-display text-3xl font-extrabold text-slate-900">Commande déjà payée</h1>
          <p className="text-slate-600">La commande {state.order} est déjà réglée. Merci !</p>
        </>
      )}
      {state.kind === "error" && (
        <>
          <AlertCircle className="w-14 h-14 text-orange-600" />
          <h1 data-testid="resume-error" className="font-display text-3xl font-extrabold text-slate-900">Impossible de reprendre la commande</h1>
          <p className="text-slate-600">{state.msg}</p>
        </>
      )}
      {state.kind !== "loading" && <Link to="/" className="btn-heat mt-2">Retour au site</Link>}
    </SimpleCard>
  );
}
